import { Property } from './interfaces';

export const concentracionMedicamento: Property = {
  title: "Concentración del Medicamento",
  type: ["integer", "null"],
};
